import { render, staticRenderFns } from "./setting-dep.vue?vue&type=template&id=f8f5228c&scoped=true"
import script from "./setting-dep.vue?vue&type=script&lang=js"
export * from "./setting-dep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f5228c",
  null
  
)

export default component.exports